module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00713.eae44e1a.jpg";